import React from "react";
import {Heading} from "@chakra-ui/react";

export const Logo = () => (
    <Heading as={'h5'} fontSize={'25px'} textAlign={'center'} fontWeight={'extrabold'}>Bed Divider For Couples</Heading>
)
